<template>
  <div id="upload-bookkeeping-file" class="upload-file-section">
    <v-card
      max-width="600"
      outlined
      tile
    >
      <v-card-title class="text-h5">
        Upload bookkeeping file
      </v-card-title>

      <v-card-text class="pb-3">
          <v-row no-gutters>
            <v-col
              cols="12">
                <p>
                  Accepted extension: csv
                </p>
                <p>
                  Where to find in EPOS: <a href="https://www.eposnowhq.com/Pages/Reporting/SageReport.aspx">Reporting > Accounting > Bookkeeping</a> 
                </p>
            </v-col>
          </v-row>
          <v-row v-if="(files1.length !== 0) && !!files1[0]" no-gutters>
            <v-col
              cols="12"
            >
                <ul>
                  <li>
                    <span>{{files1[0].name}}</span><!--  -
                    <span>{{files1[0].size}}</span> -->
                    <span v-if="files1[0].error">
                      - error: {{files1[0].error}}
                    </span>
                    <span v-else-if="files1[0].success"> - success</span>
                    <span v-else-if="files1[0].active"> - active</span>
                    <span v-else></span>
                  </li>
                </ul>
            </v-col>
          </v-row>
      </v-card-text>

      <v-card-actions>
        <div class="upload-bookkeeping-file-btns upload-btns-group">
          <v-btn color="amber darken-4" text outlined rounded
          >
            <file-upload
              input-id="bookkeeping-file"
              class="btn btn-primary"
              :post-action="uploadBookkeepingFileUrl"
              :headers="{'Authorization': sessionAuthToken}"
              extensions="csv,xls,xlsx"
              :multiple="false"
              @input-file="inputBookkeepingFile"
              v-model="files1"
              ref="uploadBookkeepingFile">
              <i class="fa fa-plus"></i>
              <span>&nbsp;Select file</span>
            </file-upload>
          </v-btn>
          <v-btn  
            class="mx-5"
            color="cyan darken-2"
            text outlined rounded
            v-if="!$refs.uploadBookkeepingFile || !$refs.uploadBookkeepingFile.active"
            @click="$refs.uploadBookkeepingFile.active = true"
          >
            <i class="fa fa-arrow-up" aria-hidden="true"></i>
            <span>&nbsp;Start Upload</span>
          </v-btn>
          <v-btn
            class="mx-5"
            color="red darken-2" 
            text outlined rounded
            v-else 
            @click.prevent="$refs.uploadBookkeepingFile.active = false"
          >
            <i class="fa fa-stop" aria-hidden="true"></i>
            <span>&nbsp;Stop Upload</span>
          </v-btn>
        </div>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import FileUpload from 'vue-upload-component';

import session from '../api/session';


export default {
  data() {
    return {
      sessionAuthToken: session.defaults.headers.Authorization,
      files1: [],
      uploadBookkeepingFileUrl: `${process.env.API_BASE_URL || ''}/api/uploads/bookkeeping_file`,
    };
  },
  components: {
    FileUpload,
  },
  computed: {
    ...mapState('mainTable', [
      'bookKeepingFile',
    ]),
  },
  methods: {
    inputBookkeepingFile(file) {
      this.$store.dispatch('mainTable/uploadBookkeepingFile', file);
    },
  },
};
</script>

<style>
.v-card__text p:last-child {
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/UploadBookKeepingFile.vue